export const notifications = {
  p1: `NEW CHECK-IN`,
  p2: `completed check-in successfully`,
  p3: `NEW SERVICE REQUEST`,
  p4: `has requested `,
  p5: ``,
  p6: ``,
  p7: ``,
  p8: ``,

  booking: {
    new: {
      title: "New booking",
      body: "A new booking has been created."
    },
    update: {
      title: "Booking updated",
      body: "A booking has been updated."
    },
    cancelled: {
      title: "Booking cancelled",
      body: "A booking has been cancelled."
    },
    request_created: {
      title: "New booking request",
      body: "A guest has sent a booking request."
    },
    request_approved: {
      title: "Booking request approved",
      body: "A booking request has been approved."
    },
    request_rejected: {
      title: "Booking request rejected",
      body: "A booking request has been rejected."
    }
  },

  types: {
    booking_new: "New Booking",
    booking_update: "Updated Booking",
    booking_cancel: "Cancelled Booking",
    booking_request: "Booking Request",
    booking_request_approved: "Approved Request",
    booking_request_rejected: "Rejected Request",
    checkin: "Check-in",
    service: "Service"
  }
};
